import React from 'react'

import { Form, Col, AsyncSelect } from '_zari/core'
import { ClearInputGroup } from 'sharedComponents/utils'

import * as ProductoCrud from 'services/producto.service'

const ProductoFormGroup = ({ value, setValue, limpiarTabla }) => {
  const loadProductosSelect = (inputValue, resolve) => {
    ProductoCrud.obtenerAsSelect2({
      busqueda: inputValue
    }).then(({ data }) => {
      resolve(data)
    })
  }

  const onChangeProductoHandler = idProducto => {
    ProductoCrud.getProducto(idProducto.value).then(({ data }) => {
      setValue({ ...data, _id: idProducto.value })
    })
    limpiarTabla()
  }

  const clickClear = () => {
    setValue(null)
    limpiarTabla()
  }

  return (
    <>
      <Form.Group>
        <Form.Label text='PRODUCTO' htmlFor='producto' sm={3} />
        <Col md={6}>
          {value ? (
            <ClearInputGroup id='input-producto-data' iValue={`${value.nombre}`} clickClear={clickClear} />
          ) : (
            <AsyncSelect selectId='productoSelect' loadOptions={loadProductosSelect} onChange={onChangeProductoHandler} />
          )}
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(ProductoFormGroup)
